export enum EnumGlobalRoutes {
    CHAT = '/chat',
    SETTINGS = '/settings',
    DASHBOARD = '/',
    LOGIN = '/login',
    FORGOT_PASSWORD = '/forgot-password',
    USER_PAGE = '/user/',
    NOTIFICATION = '/notification-management',
    SEARCH = '/search',
    NOTIFICATIONS = '/notificatios',
}

export enum EnumDispatcherRoutes {
    DISPATCHER_SHEDULING = '/dispatcher-resource-sheduling',
    DISPATCHER_TECHNICIANS = '/dispatcher-technician-management',
    DISPATCHER_CUSTOMERS_MANAGEMENT = '/dispatcher-customer-management',
    DISPATCHER_REPORTS = '/dispatcher-reports',
}

export enum EnumExecutiveRoutes {
    EXECUTIVES_PERFORMANCE_REPORTS = '/executives-performance-reports',
    EXECUTIVES_REVENUE_ANALYSIS = '/executives-revenue-analysis',
    EXECUTIVES_KPI = '/executives-work-order-kpis',
    EXECUTIVES_TECHNICIAN_PERFORMANCE = '/executives-technician-performance',
    EXECUTIVES_CUSTOMER_FEEDBACK = '/executives-customer-feedback',
}

export enum EnumTenantAdminRoutes {
    TENANT_ADMIN_SERVICE_MANAGEMENT = '/tenant-admin-service-management',
    TENANT_ADMIN_USER_MANAGEMENT = '/tenant-admin-user-management',
    TENANT_ADMIN_TEAM_MANAGEMENT = '/tenant-admin-team-management',
    TENANT_ADMIN_WORKGROUP_MANAGEMENT = '/tenant-admin-workgroup-management',
}

export const ROUTE_TITLES_CONSTANT = {
    [EnumGlobalRoutes.DASHBOARD]: 'Dashboard',
    [EnumGlobalRoutes.CHAT]: 'Chat',
    [EnumGlobalRoutes.SETTINGS]: 'Settings',
    [EnumGlobalRoutes.NOTIFICATION]: 'Notification Manager',
    [EnumDispatcherRoutes.DISPATCHER_SHEDULING]: 'Resource Scheduling',
    [EnumDispatcherRoutes.DISPATCHER_TECHNICIANS]: 'Technician Management',
    [EnumDispatcherRoutes.DISPATCHER_CUSTOMERS_MANAGEMENT]:
        'Customer Management',
    [EnumDispatcherRoutes.DISPATCHER_REPORTS]: 'Reports',
    [EnumExecutiveRoutes.EXECUTIVES_PERFORMANCE_REPORTS]: 'Performance Reports',
    [EnumExecutiveRoutes.EXECUTIVES_REVENUE_ANALYSIS]: 'Revenue Analysis',
    [EnumExecutiveRoutes.EXECUTIVES_KPI]: 'Work Order KPIs',
    [EnumExecutiveRoutes.EXECUTIVES_TECHNICIAN_PERFORMANCE]:
        'Technician Performance',
    [EnumExecutiveRoutes.EXECUTIVES_CUSTOMER_FEEDBACK]: 'Customer Feedback',
    [EnumTenantAdminRoutes.TENANT_ADMIN_SERVICE_MANAGEMENT]:
        'Service Management',
    [EnumTenantAdminRoutes.TENANT_ADMIN_USER_MANAGEMENT]: 'User Management',
    [EnumTenantAdminRoutes.TENANT_ADMIN_TEAM_MANAGEMENT]: 'Team Management',
    [EnumTenantAdminRoutes.TENANT_ADMIN_WORKGROUP_MANAGEMENT]:
        'Workgroup Management',
    [EnumGlobalRoutes.USER_PAGE]: 'User',
    [EnumGlobalRoutes.SEARCH]: 'Search',
    [EnumGlobalRoutes.NOTIFICATIONS]: 'Notifications',
} as const
